import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const pantanalShoppingTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#013765',
    },
    secondary: {
      main: '#f65a02',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#b9a69c',
    },
  },
};
